import { ChangeDetectionStrategy, Component, Input, TemplateRef, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

import { IAnalysis } from "src/app/shared/interfaces";

import { CommonConstants } from "@shared/constants";

import { FullScreenDialogComponent } from "..";

@Component({
  standalone: false,
  selector: "app-analysis-details-slide-over",
  templateUrl: "./analysis-details-slide-over.component.html",
  styleUrls: ["./analysis-details-slide-over.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnalysisDetailsSlideOverComponent {
  @Input()
  public element: IAnalysis;

  @ViewChild("analysisDetailsTemplate", { static: false })
  analysisDetailsTemplate: TemplateRef<any>;

  constructor(private dialog: MatDialog) {}

  public onFullscreen = (): void => {
    this.dialog.open(FullScreenDialogComponent, {
      width: CommonConstants.FULL_SCREEN_WIDTH(),
      height: CommonConstants.FULL_SCREEN_HEIGHT(),
      panelClass: CommonConstants.FULL_SCREEN_PANEL_CLASS,
      data: {
        template: this.analysisDetailsTemplate,
      },
    });
  };
}
